/**
 * Vencord Web — Discord client mod
 *
 * Exposes `dist/*` and `vendor/*` as static web-accessible resources, but scoped to
 * `*.discord.com`. So it is detectable, but only from Discord — the only place it runs.
 * `dist/Vencord.js` is vendor-named and reachable at a fixed URL there.
 *
 * Manifest verified against version 1.14.16.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'cbghhgpcnddeihccjmnadmkaejncjndb';

export const vencordWeb: ExtensionDefinition = {
  id: ID,
  name: 'Vencord Web',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  requiredOrigin: 'https://discord.com',
  notes:
    'dist/Vencord.js is static WAR scoped to *.discord.com, so only Discord can detect ' +
    'it. A single fetch there is conclusive.',
  signals: [
    {
      id: 'war-vencord-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch dist/Vencord.js — the vendor-named client-mod bundle, exposed only to ' +
        'Discord origins.',
      weight: 1,
      run: () => probeFetch(ID, 'dist/Vencord.js'),
    },
    {
      id: 'war-vencord-css',
      kind: 'web-accessible-resource',
      description: 'Fetch dist/Vencord.css — a second Discord-scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'dist/Vencord.css'),
    },
  ],
};
